import { BaseService } from 'core/services';
import ImportReferenceRouteService from './ImportReferenceRouteService';

class ImportReferenceService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ImportReferenceRouteService());
    }

    async upload(resource) {
        var formData = new FormData();
        formData.append('file', resource.file);  
        const url = this.routeService.upload(formData);
        const response = await this.apiClient.post(url, formData);
        return response.data || null;
    }

    getDownloadUrl(filter){
        return this.apiClient.appOptions.apiUrl + this.routeService.download(filter);
    }
}

export default ImportReferenceService;
